export * from './src/dispatcher';
export * from './src/ng2';
export * from './src/reducer';
export * from './src/state';
export * from './src/store';
export * from './src/utils';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/@ngrx/store/index.js
// module id = ../../../../@ngrx/store/index.js
// module chunks = 7